import { Component, OnInit } from "@angular/core";
import { ContactEventType } from "../../../models/contactHistory.model";
import { SidePanelBase } from "../../../../common/components/side-panel-base.class";


@Component({
    selector: 'contact-history',
    templateUrl: './contact-history.component.html',
    styleUrls: ['./contact-history.component.scss'],
    standalone: false
})
export class ContactHistoryComponent extends SidePanelBase implements OnInit {


    static componentName = 'ContactHistoryComponent';

    get contactHistoryEvents() {
        return this.componentData.data;
    }

    constructor() { super(); }

    ngOnInit() {
    }

    getEventDescription(type: ContactEventType): string {
        let result: string = "";
        switch (type) {
            case ContactEventType.AgentTypeChanged: {
                result = 'Agent Type Changed';
                break;
            }
            case ContactEventType.ContactCreation: {
                result = 'Contact Creation';
                break;
            }
            case ContactEventType.ContactUpdated: {
                result = 'Contact Modified';
                break;
            }
            case ContactEventType.ContactCanLoginChanged: {
                result = "Contact Login Status Changed";
                break;
            }
        };

        return result;
    }

    getEventClass(type: ContactEventType): string {
        switch (type) {
            case ContactEventType.ContactCreation: {
                return 'green';
            }
            case ContactEventType.AgentTypeChanged: {
                return 'blue';
            }
            case ContactEventType.ContactCanLoginChanged: {
                return 'redBackground';
            }
            default: return '';
        };

        return '';
    }
}
